import { includes } from 'ramda'
import View from './BottomNavbar'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  isHomePage: state.router.activeRoute.name === 'homepage',
  isNewsfeedPage: includes(state.router.activeRoute.name, [
    'newsFeed', 'newsFeedFr', 'newsFeedAr',
  ]),
  isLiveRadioPage: includes(state.router.activeRoute.name, [
    'liveRadioAr', 'liveRadioFr', 'liveRadio',
  ]),
  isShowsPage: includes(state.router.activeRoute.name, [
    'showsAr', 'showsFr', 'shows',
  ]),
  locale: state.router.locale,
})

const BottomNavbar = connect(mapStateToProps)(View)

export default BottomNavbar
